import { observer } from 'mobx-react';
import { SearchParameter, SearchParameters } from '../../../../ListFilter/Types';
import GenericSortFilter from '../../../GenericSortFilter';
import { statusFilterSelectOptions } from '../../Types';

interface Props {
  searchParameters: SearchParameters;
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
}

function StatusFilter({ searchParameters, updatingSearchParameters }: Props) {
  return (
    <GenericSortFilter
      labelText="Status"
      options={statusFilterSelectOptions}
      width="w-48"
      parameters={searchParameters}
      updatingParameters={updatingSearchParameters}
      sortFilterKey={'status'}
    />
  );
}

export default observer(StatusFilter);
